import { connect } from 'react-redux';

import { func_validation } from "functions";
import { userManagementActions } from "dataflow/billingPortal/actions";

import { PermissionPresentation } from './PermissionPresentation';

function mapStateToProps(state) {
    const { 
        getUserGroupList_requesting, getUserGroupList_status,
        userGroupList,

        getUserGroupPermissionList_requesting, getUserGroupPermissionList_status,
        userGroupPermissionList,

        addPermission_requesting, addPermission_status,
        addPermission_errorMsg,

        removePermission_requesting, removePermission_status,
        removePermission_errorMsg,

        isUserRecordUpdatedSuccessfully,

        userPermissions
    } = state.userManagementReducers;

    // Remove permissions that has no UI for them
    let userGroupPermissionList_formatted = 
        func_validation.removePermissionFromList(
            userGroupPermissionList, 
            [
                "Internal_AutomateList_AutomateProcess",
                "Internal_BillingSetup_DeleteAll",
                "Internal_General_Update",
                "Internal_Permission_ViewAdvance"
            ]
        );

    return {
        getUserGroupList_requesting, getUserGroupList_status,
        userGroupList,
        
        getUserGroupPermissionList_requesting, getUserGroupPermissionList_status,
        userGroupPermissionList: userGroupPermissionList_formatted,

        addPermission_requesting, addPermission_status,
        addPermission_errorMsg,

        removePermission_requesting, removePermission_status,
        removePermission_errorMsg,

        isUserRecordUpdatedSuccessfully,

        userPermissions
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getUserGroupPermissionList: (pageNo, pageSize, sort, filterOptions) => { dispatch(userManagementActions.getUserGroupPermissionList(pageNo, pageSize, sort, filterOptions)); },
        getUserGroupList: () => { dispatch(userManagementActions.getUserGroupList()); },

        addPermission: (list) => { dispatch(userManagementActions.addPermission(list)); },
        removePermission: (list) => { dispatch(userManagementActions.removePermission(list)); },
    };
}

const Permission = connect(mapStateToProps, mapDispatchToProps)(PermissionPresentation);

export default Permission;